import { v4 as uuidv4 } from 'uuid';
import { AxiosRequestConfig, AxiosResponse } from 'axios';
import Toast from '../components/Toast/index';
import { ToastNature } from './types';
import { appConfig } from '../config/app-config';

export const requestIdMiddleware = (request: AxiosRequestConfig) => {
  if (!request.headers['x-request-id']) {
    request.headers['x-request-id'] = uuidv4();
  }
  return request;
};

export const requestCallerMiddleware = (request: AxiosRequestConfig) => {
  if (!request.headers['X-Cleartax-Caller']) {
    request.headers['X-Cleartax-Caller'] = appConfig.HEADER_CALLER;
  }
  return request;
};

export const unauthorisedMiddlewareResponse = (response: AxiosResponse) => {
  if (response.status === 401) {
    if(window.location.pathname!=='/intro'){
      window.location.replace('/intro');
    }
  } else if (response.status === 403) {
    const description =
    typeof response.data === 'string' ? response.data : "You don't have perimission to perform this action";
    Toast.notify({ description, nature:ToastNature.ERROR });
  }
  return response;
};

export const unauthorisedMiddlewareResponseError = (error: any) => {
  // It will only catch network errors
  if (error.message.indexOf('401') > -1) {
    if(window.location.pathname!=='/intro'){
      window.location.replace('/intro');
    }
  } else if (error.message.indexOf('403') > -1) {
    Toast.notify({ description: "You don't have perimission to perform this action", nature:ToastNature.ERROR  });
  } else {
    Toast.notify({ description: error.message, nature:ToastNature.ERROR  });
  }
  return error;
};
